'use client';

import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getSectionByKey } from '../../services/cmsService';
import { getImageUrl } from '../../config/api';
import './HandcraftSection.css';

const defaultAboutData = {
  heading: 'Our Heritage',
  subheading: 'Preserving the artistry of Indian handlooms and crafts',
  description: "At Rangaara, our mission is to celebrate Indian heritage through timeless craftsmanship and contemporary design. We honor the artisans whose skilled hands weave stories of tradition into every thread—preserving centuries-old techniques while making them relevant for today's modern world.\n\nOur garments are more than clothing; they are emblems of cultural pride, bridging the gap between traditional Indian craftsmanship and global fashion. Each piece carries the legacy of artisan communities, the beauty of handcrafted details, and the elegance of heritage reimagined for contemporary life.",
  image: 'img/93cc167593f14ad0652725d72a9ddd59.jpg',
  btnText: 'Discover Our Craft',
  btnUrl: '/shop'
};

const HandcraftSection = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [imgError, setImgError] = useState(false);

  useEffect(() => {
    const fetchAboutSection = async () => {
      try {
        const section = await getSectionByKey('about_section');
        if (section?.content) {
          setData({
            ...defaultAboutData,
            ...section.content,
            updatedAt: section.updatedAt || section.content.updatedAt
          });
        } else {
          setData(defaultAboutData);
        }
      } catch (err) {
        console.error('Failed to fetch dynamic About section:', err);
        setData(defaultAboutData);
      } finally {
        setLoading(false);
      }
    };
    fetchAboutSection();
  }, []);

  if (loading) {
    return (
      <section className="handcraft-section">
        <div style={{ height: '30px', width: '200px', margin: '0 auto 12px auto', background: '#e5e7eb', borderRadius: '4px' }}></div>
        <div style={{ height: '16px', width: '300px', margin: '0 auto 40px auto', background: '#f3f4f6', borderRadius: '4px' }}></div>
        <div className="handcraft-container" style={{ opacity: 0.6 }}>
          <div className="handcraft-item" style={{ background: '#e5e7eb' }}></div>
          <div className="center-div" style={{ minHeight: '400px' }}></div>
        </div>
      </section>
    );
  }

  const activeData = data || defaultAboutData;
  const rawImage = typeof activeData.image === 'string' ? activeData.image : (activeData.image?.url || defaultAboutData.image);
  
  // Route through ImageKit CDN with w-1000 width, auto-quality, and cache buster
  const imageSrc = imgError 
    ? ((process.env.PUBLIC_URL || '') + '/' + defaultAboutData.image) 
    : getImageUrl(rawImage, { w: 1000, q: 82, fo: 'auto' }, activeData.updatedAt);

  const paragraphs = (activeData.description || defaultAboutData.description).split('\n\n').filter(Boolean);

  return (
    <section className="handcraft-section">
      <h2 className="common-heading center">{activeData.heading || defaultAboutData.heading}</h2>
      <p className="common-para center">{activeData.subheading || defaultAboutData.subheading}</p>

      <div className="handcraft-container">
        <div className="handcraft-item">
          <Link to={activeData.btnUrl || '/shop'} className="handcraft-item__link">
            <img
              src={imageSrc}
              alt={activeData.heading || "Handcrafted luxury design"}
              onError={() => setImgError(true)}
            />
          </Link>
        </div>
        <div className="center-div">
          <div className="handcraft-content">
            <h3 className="common-heading">RANGAARA</h3>
            <div className="handcraft-content-center">
              {paragraphs.map((p, idx) => (
                <p key={idx}>{p}</p>
              ))}
            </div>
            <Link className="handcraft-btn" to={activeData.btnUrl || '/shop'}>
              {activeData.btnText || defaultAboutData.btnText}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HandcraftSection;